import { render } from "./Maintenance.vue?vue&type=template&id=63cc2071&scoped=true"
import script from "./Maintenance.vue?vue&type=script&lang=js"
export * from "./Maintenance.vue?vue&type=script&lang=js"

import "./Maintenance.vue?vue&type=style&index=0&id=63cc2071&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63cc2071"]])

export default __exports__